import { useMemo } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core-react/tracking';

type Result = {
	trackViewAllDMsClick: () => void;
	trackViewAllDMsWithinLegislativeBodyClick: (bodyTitle: string) => void;
	trackDMProfileClick: (id: string) => void;
	trackReadFullDMResponseClick: (responseId: string) => void;
	trackDMMoreInfoClick: (dmId: string) => void;
	trackTooltipClick: () => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();

	return useMemo(
		() => ({
			trackViewAllDMsClick: () => {
				void track('view_all_dms_click');
			},
			trackViewAllDMsWithinLegislativeBodyClick: (bodyTitle: string) => {
				void track('view_all_dms_within_legislative_body_click', { role: bodyTitle });
			},
			trackDMProfileClick: (id) => {
				void track('view_dm_profile_click', { dm_id: id });
			},
			trackReadFullDMResponseClick: (responseId: string) => {
				void track('read_full_dm_response_click', { response_id: responseId });
			},
			trackDMMoreInfoClick: (dmId: string) => {
				void track('view_dm_more_info_click', {
					dm_id: dmId,
				});
			},
			trackTooltipClick: () => {
				void track('dm_section_tooltip_click');
			},
		}),
		[track],
	);
}
